import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'unauthorizedContact',
    templateUrl: './unauthorizedContact.component.html',
    styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedContact implements OnInit {

    codeErreur: string;
    timeError: boolean;
    timeIat: string;

    constructor(private route: ActivatedRoute, private oauthService: OAuthService, private storageService: StorageService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.codeErreur = params['code'];
            if (params['iat']) {
                let d = new Date(0);
                d.setUTCSeconds(params['iat']);
                this.timeIat = d.toLocaleTimeString();
                this.timeError = this.codeErreur === 'ERR-05' ? true : false;
            }
        });
    }

    logout() {
        this.storageService.clearStorage();
        this.oauthService.logOut();
    }
}